import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DesignSystemModule } from '../../../../design-system/design-system.module';
import { ChipsModule } from '../../../../global/chips/chips/chips.module';
import { MatCheckbox } from '@angular/material/checkbox';
import {ApplicationGeneric, ApplicationInstance} from '../../../../../services/model/new-application.model';
import { Subscription } from 'rxjs';

export interface PlusButtonDialogData {
	id: string;
	applications: ApplicationInstance[];
	applicationSelected: ApplicationGeneric[];
}

@Component({
  selector: 'app-add-app-dialog',
  imports: [
	  CommonModule,
	  ReactiveFormsModule,
	  TranslateModule,
	  DesignSystemModule,
	  ChipsModule,
	  MatCheckbox
  ],
  templateUrl: './add-app-dialog.component.html',
  styleUrl: './add-app-dialog.component.scss'
})
export class PlusButtonDialogComponent implements OnInit, OnDestroy {
	selectedApplications: ApplicationInstance[] = [];
	filteredApplications: ApplicationInstance[] = [];
	searchInput: FormControl = new FormControl('');
	private subscription = new Subscription();

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: PlusButtonDialogData,
		private dialogRef: MatDialogRef<PlusButtonDialogComponent>
	) {}

	ngOnInit(): void {
		this.filteredApplications = [...this.data.applications];

		this.subscription.add(
			this.searchInput.valueChanges.subscribe(searchTerm => {
				this.filterApplications(searchTerm);
			})
		);

		// Methode pour cocher les app déja présente
		for (const application of this.data.applicationSelected) {
			for (const app of this.data.applications) {
				if (app.applicationId === application.id) {
					this.selectedApplications.push(app);
				}
			}
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	filterApplications(searchTerm: string): void {
		if (!searchTerm || searchTerm.trim() === '') {
			this.filteredApplications = [...this.data.applications];
		} else {
			this.filteredApplications = this.data.applications.filter(app =>
				app.name.toLowerCase().includes(searchTerm.toLowerCase())
			);
		}
	}

	onCheckChange(app: ApplicationInstance, event: any): void {
		if (event.checked) {
			if (!this.selectedApplications.find(selectedApp => selectedApp.applicationId === app.applicationId)) {
				this.selectedApplications.push(app);
			}
		} else {
			this.selectedApplications = this.selectedApplications.filter(
				selectedApp => selectedApp.applicationId !== app.applicationId
			);
			console.log(this.selectedApplications);
		}
	}

	isApplicationSelected(app: ApplicationInstance): boolean {
		return this.selectedApplications.some(selectedApp => selectedApp.applicationId === app.applicationId);
	}

	onCancel(): void {
		this.dialogRef.close({ result: false, type: 'create' });
	}

	onSave(): void {
		this.dialogRef.close({
			result: this.selectedApplications,
			base: this.data.applicationSelected,
			capacityId: this.data.id
		});
	}
}
